import React from "react";
import { ContentSection, ButtonRenderProps } from "sprint-common-web";

import { AspectRatiosDataProvider } from "../../../../../../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import { AspectTypesDataProvider } from "../../../../../../../common/data/lookup-data-providers/AspectTypesDataProvider";
import { StandardsDataProvider } from "../../../../../../../common/data/lookup-data-providers/StandardsDataProvider";
import {
    ensureVideoFileRecordDetails,
    isFileRecordDetailsEditable
} from "../../../../../../common/file-record-details/FileRecordDetails";
import { VideoFileRecordTechnicalView } from "../../../../../../common/file-record-details/technical/VideoFileRecordTechnicalView";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import {
    EditVideoTechnicalButtonAside,
    EditVideoTechnicalButtonAsideProps
} from "./edit/EditVideoTechnicalButtonAside";

export const VideoFileRecordTechnicalSection = (): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    ensureVideoFileRecordDetails(fileRecordDetails);

    const editVideoTechnicalInfoButtonAside: ButtonRenderProps<EditVideoTechnicalButtonAsideProps> = {
        fileRecordId: fileRecordDetails.id,
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditVideoTechnicalButtonAside
    };

    const buttons = [editVideoTechnicalInfoButtonAside];

    return (
        <AspectTypesDataProvider>
            <AspectRatiosDataProvider>
                <StandardsDataProvider>
                    <ContentSection header="Technical" isLoading={isLoading} style={{ height: 300 }} buttons={buttons}>
                        <VideoFileRecordTechnicalView fileRecordDetails={fileRecordDetails} />
                    </ContentSection>
                </StandardsDataProvider>
            </AspectRatiosDataProvider>
        </AspectTypesDataProvider>
    );
};
